import { z } from "zod";

export const DischargeLetterPneumologyFormSchema = z.object({
  additional_diagnostic_findings: z.string().optional(),
  admission_medications: z.string().optional(),
  admission_reason: z.string().optional(),
  anamnesis: z.string().optional(),
  clinical_examination: z.string().optional(),
  concluding_remarks: z.string().optional(),
  diagnoses: z.string().optional(),
  discharge_medications: z.string().optional(),
  discharge_summary: z.string().optional(),
  next_provider: z.string().optional(),
  parameters: z.string().optional(),
  prescribed_regulations: z.string().optional(),
  recommendations: z.string().optional(),
  therapy: z.string().optional(),
});
